import { IStairConfig, IStepGeometry, IStringerGeometry } from '@stair-craft/common/util';

import { tetivaBoard } from '../shared-tetiva-board/tetiva-board';

// Тетива — flat side board that houses the tread and riser ends. Its top runs above the nosing
// line from the front of the first nosing to the slab edge, cut flush with the upper floor.
export function generateTetivaStringer(
    steps: IStepGeometry[],
    config: IStairConfig,
    riserHeight: number,
    side: 'left' | 'right'
): IStringerGeometry {
    const lastStep: IStepGeometry = steps[steps.length - 1];
    const treadDepth: number = steps[0].treadDepth;
    return tetivaBoard({
        side,
        riserHeight,
        treadDepth,
        origin: { x: side === 'left' ? 0 : config.stairWidth, z: steps[0].position.z },
        direction: { x: 0, z: 1 },
        firstTop: steps[0].position.y,
        noseLength: config.noseLength,
        from: -config.noseLength,
        to: lastStep.position.z + lastStep.treadDepth - steps[0].position.z,
        maxY: config.floorHeight + config.floorThickness,
    });
}
